import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import * as Icon from "@main/pages/shared/icons/icons";
import styled, { css } from "styled-components";

export const TicketDetailsBar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 2.8rem;
  margin-bottom: 4rem;
  align-items: center;
`;

export const LockIcon = styled.div<{ $disabled?: boolean }>`
  margin-top: 0.3rem;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  width: 3.6rem;

  ${(props) =>
    props.$disabled &&
    css`
      cursor: not-allowed;
    `}
`;

export const UnlockedIcon = styled(Icon.UnlockedIcon)<{ $disabled?: boolean }>`
  width: 2rem;
  height: 2rem;
  ${(props) =>
    !props.$disabled &&
    css`
      path {
        fill: ${vars.colors.grey60};
      }
      &:hover {
        path {
          fill: ${vars.colors.grey30};
        }
      }
    `}
`;

export const DeleteMergeContainer = styled.div`
  height: 4rem;
  border-radius: 1rem;
  border: 1px solid ${vars.colors.grey90};
  background: ${vars.colors.grey100};
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const DuplicateContainer = styled.div`
  cursor: pointer;

  svg {
    margin: 0.8rem;
    width: 2rem;
    height: 2rem;

    path {
      stroke: ${vars.colors.grey30};
    }
  }
  position: relative;
`;

export const DeleteContainer = styled.div`
  justify-content: center;
  cursor: pointer;
`;

export const ShareTicketContainer = styled.div`
  height: 4rem;
  border-radius: 1rem;
  border: 1px solid ${vars.colors.grey90};
  display: flex;
  align-items: center;
  padding: 0 1rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ShareTicketText = styled(Paragraph)`
  color: ${vars.colors.grey50};
  font-size: 1.2rem;
  white-space: nowrap;
`;

export const CopyContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.2rem;
  margin-left: 0.2rem;
  cursor: pointer;
`;
